import React from 'react'
import { useProfilePrompt } from '../../useProfilePrompt'
import { RenderItemProps } from '../types'
import { BaseCard } from './BaseCard'
import { SliderOnboarding } from '@/components/SliderOnboarding'

export const WorkSatisfactionCard = ({ item }: RenderItemProps) => {
  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <SliderOnboarding {...prompt.form.register('satisfaction_at_work')} labelVariants={['h4']} />
    </BaseCard>
  )
}
